// import EffectIcon from "./effect-icons";
import AmbianceCoffeeAtmosphere from "./ambiance-coffee-atmosphere";
import AmbianceRainAtmosphere from "./ambiance-rain-atmosphere";
import {
  formatAdjustableTileValue,
  sliderFillPct,
} from "./tile-slider";

const AMBIANCE_ATMOSPHERES = {
  rainy: "rainy",
  coffeeShop: "coffee",
  seashore: "seashore",
};

export default function ModeTile({
  mode,
  isProFeaturesLocked,
  holdingTileKey,
  draggingTileKey,
  revealingTileKey,
  releasingTileKey,
  fillGrowingKeys,
  onUpgradeClick,
  onAdjustablePointerDown,
  onAdjustablePointerMove,
  onAdjustablePointerUp,
  onAdjustablePointerCancel,
  onAdjustableClick,
}) {
  const isActive = !!mode.active;
  const isAdjustable = !!mode.slider && !isProFeaturesLocked;
  const isHolding = holdingTileKey === mode.key;
  const isEngaged = isActive || isHolding;
  const targetFillPct =
    isAdjustable && isEngaged ? sliderFillPct(mode.slider) : 0;
  const isFillGrowing = !!fillGrowingKeys[mode.key];
  const displayFillPct = isFillGrowing ? 0 : targetFillPct;
  const isDragging = draggingTileKey === mode.key;
  const isRevealing = revealingTileKey === mode.key;
  const isReleasing = releasingTileKey === mode.key;
  const showValue =
    isAdjustable && (isDragging || isRevealing || isReleasing);
  const reserveLabelText = showValue && !isReleasing;
  const ambianceAtmosphere = AMBIANCE_ATMOSPHERES[mode.key] ?? null;
  const tileClassName = [
    "mode-tile",
    !ambianceAtmosphere && `mode-tile--icon-${mode.key}`,
    isEngaged && "mode-tile--active",
    isAdjustable && "mode-tile--adjustable",
    isAdjustable && isEngaged && targetFillPct > 0 && "mode-tile--has-value",
    !isAdjustable && !isProFeaturesLocked && "mode-tile--toggle",
    isProFeaturesLocked && "mode-tile--locked",
    isDragging && "mode-tile--dragging",
    isFillGrowing && "mode-tile--fill-growing",
    isReleasing && "mode-tile--release-bounce",
    ambianceAtmosphere && "mode-tile--ambiance",
    ambianceAtmosphere && `mode-tile--ambiance-${ambianceAtmosphere}`,
  ]
    .filter(Boolean)
    .join(" ");

  const labelContent = isAdjustable ? (
    <span className="mode-tile__label-content">
      <span
        className={[
          "mode-tile__label-text",
          reserveLabelText && "mode-tile__label-text--reserve",
          isReleasing && "mode-tile__label-text--enter",
        ]
          .filter(Boolean)
          .join(" ")}
        aria-hidden={reserveLabelText}
      >
        {mode.label}
      </span>
      {showValue && (
        <span
          className={`mode-tile__label-value ${isReleasing ? "mode-tile__label-value--out" : ""}`}
        >
          {formatAdjustableTileValue(mode.slider)}
        </span>
      )}
    </span>
  ) : (
    <span className="mode-tile__label-text">{mode.label}</span>
  );

  const label = (
    <span className="mode-tile__label">
      {/* {!ambianceAtmosphere && (
        <span className="mode-tile__icon-slot" aria-hidden="true">
          <EffectIcon modeKey={mode.key} />
        </span>
      )} */}
      {labelContent}
    </span>
  );

  if (isAdjustable) {
    return (
      <button
        type="button"
        className={tileClassName}
        style={
          isEngaged
            ? { "--mode-tile-fill": displayFillPct / 100 }
            : undefined
        }
        onPointerDown={(event) => onAdjustablePointerDown(event, mode)}
        onPointerMove={onAdjustablePointerMove}
        onPointerUp={(event) => onAdjustablePointerUp(event, mode)}
        onPointerCancel={onAdjustablePointerCancel}
        onClick={() => onAdjustableClick(mode)}
      >
        {isEngaged && ambianceAtmosphere === "rainy" && (
          <AmbianceRainAtmosphere />
        )}
        {isEngaged && ambianceAtmosphere === "coffee" && (
          <AmbianceCoffeeAtmosphere />
        )}
        {label}
      </button>
    );
  }

  return (
    <button
      type="button"
      className={tileClassName}
      onClick={() => {
        if (isProFeaturesLocked) {
          onUpgradeClick();
          return;
        }
        mode.onToggle();
      }}
    >
      {label}
    </button>
  );
}
